module.exports = __webpack_public_path__ + "static/media/linkedin.007eb41a.svg";